const FACE_CROP_DIVISIONS = new Set([2, 3, 4]);

export const DRIVER_AVATAR_FACE_TOP_CLASS = 'driver-avatar-face-top';

/** Infère la division pilote depuis un chemin `/assets/drivers/dN/…`. */
export function inferDivisionFromDriverImagePath(imagePath?: string | null): number | undefined {
  const path = imagePath?.trim();
  if (!path) return undefined;
  const match = path.match(/\/assets\/drivers\/d([1-4])\//i);
  if (!match) return undefined;
  const division = parseInt(match[1], 10);
  return Number.isFinite(division) ? division : undefined;
}

/** D2–D4 : photos corps entier → cadrer tête + haut du corps (classe + zoom CSS). */
export function shouldCropDriverFaceTop(
  division?: number | null,
  imagePath?: string | null
): boolean {
  const resolved = division ?? inferDivisionFromDriverImagePath(imagePath);
  return resolved != null && FACE_CROP_DIVISIONS.has(resolved);
}

export function driverAvatarImageClass(
  baseClass: string,
  division?: number | null,
  imagePath?: string | null
): string {
  if (!shouldCropDriverFaceTop(division, imagePath)) return baseClass;
  return `${baseClass} ${DRIVER_AVATAR_FACE_TOP_CLASS}`;
}
